// extracted by mini-css-extract-plugin
export default {"trailsText":"centertextstyles_trailsText__65rG2","container":"centertextstyles_container__xpgT-"};